import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
const IconNavbar = ({title,icon}) => {
  return (
    <>
      {" "}
      <div className="navbar-menu__icon-box flex flex-column">
        <FontAwesomeIcon icon={icon} />
        <label>{title}</label>
      </div>
      <div className="navbar-menu__triangle"></div>
    </>
  );
};

export default IconNavbar;
